export default __webpack_public_path__ + "static/media/pass_bg.b0031e83.png";